/* ==========================================================================
   Feature Announcement Slider Section - Start
========================================================================== */
$(function () {
    $('[data-feature-announcement-slider]').each(function () {
        const section = $(this);
        const slider = section.find('.feature-announcement-slider__swiper')[0];

        if (!slider) return;

        let swiper = null;

        function initSlider() {
            if (swiper) return;
            const prevButton = section.find('.feature-announcement-slider__arrow--prev')[0];
            const nextButton = section.find('.feature-announcement-slider__arrow--next')[0];
            swiper = new Swiper(slider, {
                slidesPerView: 1,
                spaceBetween: 0,
                speed: 500,
                autoplay: true,
                loop: true,
                watchOverflow: true,
                observer: true,
                observeParents: true,
                navigation: {
                    prevEl: prevButton,
                    nextEl: nextButton,
                },
                breakpoints: {
                    565: {
                        slidesPerView: 2
                    }
                }
            });
        }

        function destroySlider() {
            if (!swiper) return;
            swiper.destroy(true, true);
            swiper = null;
        }

        function toggleSlider() {
            if (window.innerWidth < 750) {
                initSlider();
            } else {
                destroySlider();
            }
        }

        toggleSlider();
        $(window).on('resize', toggleSlider);
    });
});
/* ==========================================================================
   Feature Announcement Slider Section - End
========================================================================== */


/* ==========================================================================
   Theme Carousel Section - Start
========================================================================== */
$(function () {
    const Slideshow = customElements.get('slideshow-component');

    if (!Slideshow) {
        console.warn('Slideshow component not found.');
        return;
    }

    console.log('Horizon slideshow patch loaded.');

    // Move one slide at a time instead of visibleSlides.length
    Object.defineProperty(Slideshow.prototype, 'nextIndex', {
        configurable: true,
        get() {
            return this.current + 1;
        }
    });

    Object.defineProperty(Slideshow.prototype, 'previousIndex', {
        configurable: true,
        get() {
            return this.current - 1;
        }
    });

    // Fix resume()
    Slideshow.prototype.resume = function () {
        if (!this.autoplay || this.paused) return;

        this.suspend();
        this.play();
    };

    // Respect pause-on-hover setting
    const originalSetup = Slideshow.prototype.connectedCallback;

    Slideshow.prototype.connectedCallback = async function () {
        await originalSetup.call(this);

        if (!this.hasAttribute('pause-on-hover')) {
            this.removeEventListener('mouseenter', this.suspend);
            this.removeEventListener('mouseleave', this.resume);
        }
    };

    console.log('Horizon slideshow patched successfully.');
});
/* ==========================================================================
   Theme Carousel Section - Start
========================================================================== */


/* ==========================================================================
   Featured Logo Carousel Section - Start
========================================================================== */
$(function () {
    $('[data-logo-carousel]').each(function () {
        const section = $(this);
        const slider = section.find('.featured-logo-carousel__swiper').get(0);

        if (!slider) return;

        const autoplay = section.data('autoplay');
        const loop = section.data('loop');
        const pauseOnHover = section.data('hover');
        const speed = Number(section.data('speed'));
        const delay = Number(section.data('delay'));
        const desktop = Number(section.data('desktop'));
        const tablet = Number(section.data('tablet'));
        const mobile = parseFloat(section.data('mobile'));

        const swiper = new Swiper(slider, {
            slidesPerView: mobile,
            speed: speed,
            loop: loop,
            watchOverflow: true,
            observer: true,
            observeParents: true,
            grabCursor: true,
            allowTouchMove: true,
            autoplay: autoplay ? {
                delay: delay,
                disableOnInteraction: false,
                pauseOnMouseEnter: pauseOnHover
            } : false,
            breakpoints: {
                750: {
                    slidesPerView: tablet
                },
                990: {
                    slidesPerView: desktop
                }
            }
        });
    });
});
/* ==========================================================================
   Featured Logo Carousel Section - End
========================================================================== */


/* ==========================================================================
   Why Fancelite Section - End
========================================================================== */
$(function () {
    $('[data-typing]').each(function () {

        const typing = $(this);
        const text = typing.find('.why-fancelite__typing-text');

        const words = typing.data('words');

        if (!words) return;

        const list = words.toString().split('|').map(function (word) {
            return word.trim();
        }).filter(Boolean);

        if (!list.length) return;

        const settings = {
            typeSpeed: 60,
            startDelay: 1000,
            backSpeed: 60,
            backDelay: 1000,
            loop: true,
            fadeOut: true,
            smartBackspace: true
        };

        let wordIndex = 0;
        let charIndex = 0;
        let deleting = false;
        let stopIndex = 0;
        let timeout;

        function commonPrefix(a, b) {
            let i = 0;

            while (
                i < a.length &&
                i < b.length &&
                a.charAt(i) === b.charAt(i)
            ) {
                i++;
            }

            return i;
        }

        function nextWord() {

            wordIndex++;

            if (wordIndex >= list.length) {

                if (settings.loop) {
                    wordIndex = 0;
                } else {
                    return false;
                }
            }

            return true;
        }

        function type() {

            const current = list[wordIndex];
            const next = list[(wordIndex + 1) % list.length];

            if (!deleting) {

                text.text(current.substring(0, charIndex + 1));

                charIndex++;

                if (charIndex >= current.length) {

                    deleting = true;

                    if (settings.smartBackspace && list.length > 1) {
                        stopIndex = commonPrefix(current, next);
                    } else {
                        stopIndex = 0;
                    }

                    timeout = setTimeout(type, settings.backDelay);
                    return;
                }

                timeout = setTimeout(type, settings.typeSpeed);

            } else {

                if (charIndex > stopIndex) {

                    charIndex--;

                    text.text(current.substring(0, charIndex));

                    timeout = setTimeout(type, settings.backSpeed);

                } else {

                    if (settings.fadeOut) {

                        text.css('opacity', '0');

                        timeout = setTimeout(function () {

                            if (!nextWord()) return;

                            deleting = false;

                            charIndex = stopIndex;

                            text.text(list[wordIndex].substring(0, stopIndex));

                            text.css('opacity', '1');

                            timeout = setTimeout(type, settings.startDelay);

                        }, 200);

                    } else {

                        if (!nextWord()) return;

                        deleting = false;

                        charIndex = stopIndex;

                        text.text(list[wordIndex].substring(0, stopIndex));

                        timeout = setTimeout(type, settings.startDelay);

                    }

                }

            }

        }

        text.css({
            opacity: 1,
            transition: 'opacity .2s ease'
        });

        timeout = setTimeout(type, settings.startDelay);

    });
});

$(function () {
    $('[data-why-fancelite]').each(function () {
        const section = $(this);
        const slider = section.find('.why-fancelite__slider')[0];

        if (!slider) return;

        const prevButton = section.find('.why-fancelite__arrow--prev')[0];
        const nextButton = section.find('.why-fancelite__arrow--next')[0];
        const pagination = section.find('.why-fancelite__pagination')[0];

        new Swiper(slider, {
            speed: 1000,
            loop: true,
            infinite: true,
            autoplay: {
                delay: 2000,                // Wait 2 seconds between slides
                disableOnInteraction: false, // Continue autoplay after swipe
                pauseOnMouseEnter: true      // Pause on hover
            },
            watchOverflow: true,
            observer: true,
            observeParents: true,
            grabCursor: true,
            slidesPerView: 1,
            spaceBetween: 20,
            // navigation: {
            //     prevEl: prevButton,
            //     nextEl: nextButton
            // },
            breakpoints: {
                480: {
                    slidesPerView: 2
                },
                750: {
                    slidesPerView: 3
                },
                1150: {
                    slidesPerView: 3
                }
            }
        });
    });
});
/* ==========================================================================
   Why Fancelite Section - End
========================================================================== */


/* ==========================================================================
   Video Gallery Slider - START
========================================================================== */
// document.addEventListener('DOMContentLoaded', () => {
//     const lightbox = document.querySelector('[data-video-lightbox]');
//     if (!lightbox) return;
//     const container = lightbox.querySelector('[data-video-container]');
//     const triggers = document.querySelectorAll('[data-video-trigger]');
//     function openLightbox(type, src) {
//         let html = '';
//         switch (type) {
//             case 'shopify':
//             case 'custom':
//                 html = `
//                     <video
//                         controls
//                         autoplay
//                         playsinline
//                         preload="metadata"
//                     >
//                         <source src="${src}">
//                     </video>
//                 `;
//                 break;

//             case 'youtube':
//                 html = `
//                     <iframe
//                         src="https://www.youtube.com/embed/${src}?autoplay=1&rel=0"
//                         allow="autoplay; encrypted-media"
//                         allowfullscreen>
//                     </iframe>
//                 `;
//                 break;

//             case 'vimeo':
//                 html = `
//                     <iframe
//                         src="https://player.vimeo.com/video/${src}?autoplay=1"
//                         allow="autoplay; fullscreen"
//                         allowfullscreen>
//                     </iframe>
//                 `;
//                 break;
//         }
//         container.innerHTML = html;

//         const video = container.querySelector('video');
//         if (video) {
//             video.addEventListener('loadedmetadata', () => {
//                 lightbox.hidden = false;

//                 requestAnimationFrame(() => {
//                     lightbox.classList.add('is-active');
//                 });
//             }, { once: true });
//         } else {
//             lightbox.hidden = false;

//             requestAnimationFrame(() => {
//                 lightbox.classList.add('is-active');
//             });
//         }
//         document.body.style.overflow = 'hidden';
//     }

//     function closeLightbox() {
//         lightbox.classList.remove('is-active');

//         setTimeout(() => {
//             container.innerHTML = '';
//             lightbox.hidden = true;
//         }, 300);

//         document.body.style.overflow = '';
//     }

//     triggers.forEach(trigger => {
//         trigger.addEventListener('click', () => {
//             openLightbox(
//                 trigger.dataset.videoType,
//                 trigger.dataset.videoSrc
//             );
//         });
//     });

//     const closeButton = lightbox.querySelector('.video-lightbox__close');

//     closeButton.addEventListener('click', closeLightbox);

//     /* Close when clicking outside the video */
//     lightbox.addEventListener('click', (event) => {
//         if (!event.target.closest('.video-lightbox__content')) {
//             closeLightbox();
//         }
//     });

//     /* Prevent clicks inside the video from closing */
//     container.addEventListener('click', (event) => {
//         event.stopPropagation();
//     });

//     document.addEventListener('keydown', event => {
//         if (event.key === 'Escape' && lightbox.classList.contains('is-active')) {
//             closeLightbox();
//         }
//     });
// });

// document.addEventListener('DOMContentLoaded', () => {
//     const lightbox = document.querySelector('[data-video-lightbox]');
//     const footer = document.querySelector('footer');

//     if (lightbox && footer) {
//         footer.parentNode.insertBefore(lightbox, footer);
//     }
// });
document.addEventListener("DOMContentLoaded", () => {
    Fancybox.bind("[data-fancybox]", {
        animated: true,
        dragToClose: true,
        placeFocusBack: true
    });
});
/* ==========================================================================
   Video Gallery Slider - END
========================================================================== */


/* ==========================================================================
   Product Description Section JS - START
========================================================================== */
document.addEventListener("DOMContentLoaded", function () {

    const buttons = document.querySelectorAll(".product-tabs .tab-btn");

    buttons.forEach(function(btn){

        btn.addEventListener("click",function(){

            const parent=this.closest(".product-tabs");

            parent.querySelectorAll(".tab-btn").forEach(function(b){
                b.classList.remove("active");
            });

            parent.querySelectorAll(".tab-content").forEach(function(c){
                c.classList.remove("active");
            });

            this.classList.add("active");

            parent.querySelector("#"+this.dataset.tab).classList.add("active");

        });

    });

});
/* ==========================================================================
   Product Description Section JS - END
========================================================================== */


/* ==========================================================================
   Judge.me Tab Open - START
========================================================================== */
document.addEventListener('click', function (e) {
    const badge = e.target.closest('.jdgm-preview-badge');

    if (!badge) return;

    console.log('Judge.me badge clicked');

    e.preventDefault();

    const descriptionTab = document.querySelector('[data-tab="description"]');
    const reviewsTab = document.querySelector('[data-tab="reviews"]');

    const descriptionContent = document.getElementById('description');
    const reviewsContent = document.getElementById('reviews');

    if (!reviewsTab || !reviewsContent) {
        console.log('Reviews tab not found');
        return;
    }

    document.querySelectorAll('.tab-btn').forEach((tab) => {
        tab.classList.remove('active');
    });

    document.querySelectorAll('.tab-content').forEach((content) => {
        content.classList.remove('active');
    });

    reviewsTab.classList.add('active');
    reviewsContent.classList.add('active');

    document.querySelector('.product-tabs').scrollIntoView({
        behavior: 'smooth',
        block: 'start',
    });

    console.log('Reviews tab activated');
  },
  true
);
/* ==========================================================================
   Judge.me Tab Open - END
========================================================================== */